import React,  { Component,useState } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "../layout/header3";
import Footer from "../layout/footer4";
import ProductSlider from "../element/productSlider";
import ProductGallerySlider from "../element/productGallerySlider";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

// import 'react-tabs/style/react-tabs.css';

const bg = require("../../images/banner/bnr5.jpg");

const Data = [
  {
    ProductName: "PuraDyn Filtre Sistemi ",
    Html: "",
    url: { image: "" },
  },
  {
    ProductName: "PuraDyn MTS-40",
    url: { image: "" },
    title:
      "<p> MTS-40, motor, hidrolik ve şanzımanlarda kullanılan yağları sürekli olarak temizlenmesi için tasarlanmış çok aşamalı, yüksek verimli bir bypass yağ filtrasyon sistemidir.</p> <p >Böbrek diyaliz makinesiyle aynı şekilde çalışan PURADYN Sistemi, az miktarda motor yağını yavaş bir akış hızında dolaştırır. Patentli bir çözeltiden yararlanarak, filtre sürekli ve güvenli bir şekilde kirleri yağdan arındırır ve temizlenmiş yağı motora geri vermeden önce temel katkı maddelerini doldurur.</p>",
  },
  {
    ProductName: "PuraDYN MTS-60",
    url: { image: "" },
  },
  {
    ProductName: "PuraDYN MTS-240",
    url: { image: "" },
    title:"<p class='ql-align-justify'>MTS-240, motor, hidrolik ve şanzımanlarda kullanılan yağları sürekli olarak temizlenmesi için tasarlanmış çok aşamalı, yüksek verimli bir bypass yağ filtrasyon sistemidir.</p><p class='ql-align-justify'>Böbrek diyaliz makinesiyle aynı şekilde çalışan PURADYN Sistemi, az miktarda motor yağını yavaş bir akış hızında dolaştırır. Patentli bir çözeltiden yararlanarak, filtre sürekli ve güvenli bir şekilde kirleri yağdan arındırır ve temizlenmiş yağı motora geri vermeden önce temel katkı maddelerini doldurur.</p><h2>Filtreleme Aşamaları</h2><ol><li>Adım :&nbsp;Yağ sisteme 22-40 LPH (motor) ve 45-60 LPH (hifrolik) hızında sisteme girer.</li><li>Adım :&nbsp;POLIDRY teknolojisi ile içindeki su uzaklaştırılır.</li><li>Adım :&nbsp;Yağın yavaş akışı süresince yağın referans değerlerine göre katkı maddeleri eklenir.</li><li>Adım :&nbsp;Yağ kimyasal aşılama tekniğiyle CPG ile işlenmiş pamuk boyunca filtrelenmeye devam eder</li><li>Adım :&nbsp;Yağ özgül ağırlığına bağlı bir hızla motora geri döner.</li></ol><h2>Teknik Özellikler</h2><p>AğırlıkKapasiteFiltreli Ünite20 kgMax. yağ haznesi kapasitesi322 ltAmbalajlı olarak23,6 kgİlave yağ11,4 ltÇıkarılan parçalar1785 grÇıkarılan su800 mlGerekli Dikey Boşluk51 cmYaklaşık çalışma sıcaklığı:104&nbsp;℃Ölçüler-TotalLikit özellikleriYükseklik75 cmMax. giriş basıncı&nbsp;690 kPaGenişlik25 cmFiltrasyonda ki debi aralığı (motor)22-40 LPHDerinlik30 cmFiltrasyonda ki debi aralığı (hidrolik)&nbsp;45-60 LPH</p><p>Yukarıda belirtilen özellikler yaklaşık değerlerdir ve yağın özelliğine göre değişiklik gösterebilir.</p><h2>Bazı Öze MTS-240 Uygulamaları</h2><p>Parça NumarasıUygulamaÜreticiİmalatMax. Yağ HaznesiMax. Basınç01-70002MTS-DLJeneratörCaterpillarC3512322 lt690 kPa01-71002MTS-DL6KamyonCaterpillarC3512322 lt690 kPa01-70002MTS-DL4JeneratörCumminsQSK50322 lt690 kPa01-70003MTS-DL ( 2 Ünite)Jeneratör (derin hazne)CaterpillarC3512644 lt690 kPa01-71003MTS-DL8 (2 Ünite)Jeneratör (derin hazne/SNG)JenbacherJ320644 lt690 kPa01-70006MTS-DL7 (3 Ünite)Jeneratör (derin hazne/Merine)CaterpillarC3516965 lt690 kPa01-70006MTS-DL9 (3 ünite)KompresörIngersoll RandKVG-123965 lt690 kPa</p><p class='ql-align-justify'>Listede belirtilen max. basınç değerleri makinalarda kullanılan basınç düşürme valflerine göre ölçülmüştür.</p><p class='ql-align-justify'>Hidrolik yağ uygulamalarında çoklu sistemler kullanılabilir ve yüksek basınçlı sistemlere uygulanabilir.k</p><p><br></p>"
  },
];
const MyEditor = () => {
  const [text, setText] = useState('');

  const handleChange = (value) => {
    setText(value);
    console.log(text);
  };
  return (
    <div>
      <ReactQuill value={text} onChange={handleChange} />
    </div>
  );
};
class shopProductDetails extends Component {
  render() {
    const { match } = this.props;
    const { id } = match.params;
    

    console.log(match);
    return (
      <>
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr overlay-black-middle bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">{Data[id - 1].ProductName}</h1>
                <div className="breadcrumb-row">
                  <ul className="list-inline">
                    <li>
                      <Link to="/">AnasayfaWWW </Link>
                    </li>
                    <li>Ürün Detaywww</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
         
          <div className="section-full content-inner bg-white">
            <div className="container woo-entry">
              <div className="row m-b30">
                { Data[id - 1].url.image !== "" ?
                <div className="col-md-5 col-lg-5 col-sm-12 m-b30">
                  <ProductGallerySlider props={Data[id - 1].url} />
                </div>
                : <></>}
                <div className="col-md-7 col-lg-7 col-sm-12">
                  <div className="dlab-post-title">
                    <h4 className="post-title">
                      <Link to="#">{Data[id - 1].ProductName}</Link>
                    </h4>
                   
                  <div dangerouslySetInnerHTML={{ __html: Data[id - 1].title }} />

                    <div className="dlab-divider bg-gray tb15">
                      <i className="icon-dot c-square"></i>
                    </div>
                  </div>
                </div>
              </div>
  
            
            </div>
          </div>

          <div className="section-full p-t50 p-b20 bg-primary text-white">
          <div className="container">
                <div className="row">
                  <div className="col-lg-9 text-white">
                    <h2 className="title">
                    Projeleriniz için size yardımcı olabiliriz. <br/>Detaylı bilgi ve fiyat teklif için lütfen talebinizi iletin.
                    </h2>
                  </div>
                  <div className="col-lg-3 d-flex">
                    <Link
                      to="/contact"
                      className="site-button black align-self-center ms-auto btnhover14"
                    >
                      Bize Ulaş
                    </Link>
                  </div>
                </div>
              </div>
          </div>
        </div>
        <Footer hideContactInfo />
      </>
    );
  }
}
export default shopProductDetails;
